import './index.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/smSupplierManagement';
import { supplierDetailHOC } from '../components/Detail';
import { DetailProps } from '../components/Detail/supplierDetailHOC';
import classnames from 'classnames';
import { CardPage } from 'components';
import Header from './Header';
import PageFooter from '@mpc/common/src/features/PageFooter';
import SupplierDetailBase from '@mpc/common/src/features/SupplierNew/DetailExternal';
import { getVendorStorage } from '@mpc/common/src/utils';
import { useRequest } from 'ahooks';
import { PartnershipRequestInvoker } from '@purchase/supplier';
import { formatSupplierDetailExternal } from '@mpc/common/src/features/SupplierNew/DetailExternal/format';

export const BANK_INFO_KEYS = {
  bank_name: {},
  bank_number: {},
};

class CompanyInfoDetail extends Component<DetailProps, any> {
  getAttachementDownloadUrl = (attachId: number, withDownload?: boolean) => {
    const { getAttachementDownloadLink } = this.props;

    if (getAttachementDownloadLink) {
      return getAttachementDownloadLink(attachId, withDownload);
    }

    return `api/v1/attachments/${attachId}?download=attachment`;
  }

  public render() {
    const {
      prefixCls,
      history,
      location,
      data: { permit_buttons },
      readOnly = true,
    } = this.props;

    const classes = classnames({
      [`${prefixCls}-detail`]: true,
    });

    const { vendorId } = getVendorStorage();

    const { data: vendorDetailData, loading } = useRequest(async () => {
      const res = await PartnershipRequestInvoker.getInstance().partnerShipOpenApiVendorVendorDetail({ vendorId })
      return formatSupplierDetailExternal(res?.data)
    })
  
    return (
      <CardPage className={classes}>
        <Header
          history={history}
          location={location}
          permitButtons={permit_buttons}
          readOnly={readOnly}
        />
        <SupplierDetailBase vendorDetailData={vendorDetailData} loading={loading} vendorId={vendorId} />
        <PageFooter />
      </CardPage>
    );
  }
}

const mapStateProps = (state: any, ownProps: any) => {
  const data = ownProps.data || state.smSupplierManagement.detail;
  return {
    data,
  };
};

export function mapDispatchToProps(
  dispatch: Dispatch<actions.SupplierManagementActions>,
  ownProps: any,
) {
  return bindActionCreators(
    {
      getDetail: ownProps.getDetail || actions.getDetail,
    },
    dispatch,
  );
}

export default connect(
  mapStateProps,
  mapDispatchToProps,
)(supplierDetailHOC(CompanyInfoDetail));
